import { useEffect, useState } from 'react';
import { getAppConfig } from 'src/api/pmApi';
import { apiErrorHandling } from '../api/apierrorhandling';
import { IAppConfig } from '../models';
import { awaitUtil } from 'src/util/utils';
import { getUser } from 'src/api/stoApi';

export const useAppConfig = () => {
  const [appConfig, setAppConfig] = useState<IAppConfig | null>(null);
  useEffect(() => {
    const load = async () => {
      try {
        const [response] = await awaitUtil(getUser());
        const partnerId = response?.data?.data?.partner.id || 'brickwise';
        if (partnerId) {
          const result = await getAppConfig(partnerId);
          const appConfig = result.data.data;
          setAppConfig(appConfig);
        }
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
      }
    };
    load();
  }, []);
  return appConfig;
};
